import cls from "classnames";
import React from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import Tooltip from "./../../../wix-rich-content-common/lib/Tooltip.js";
import { CheckIcon } from "../../assets/icons/CheckIcon.js";
import { LoaderIcon } from "../../assets/icons/LoaderIcon.js";
import { NonEditableIcon } from "../../assets/icons/NonEditableIcon.js";
import {
  POLLS_ANSWER_IMAGE,
  POLLS_ANSWER_TEXT_INPUT,
  POLLS_ITEM_PERCENTAGE_PREVIEW
} from "../../data-hooks.js";
import { ImageUpload } from "../image-upload/ImageUpload.js";
import { TextField } from "../text-field/TextField.js";
import styles from "./option-scss.js";
import { PollOptionBase } from "./PollOptionBase.js";
import { RemoveOption } from "./RemoveOption.js";
class PollListOption extends PollOptionBase {
  getCustomStyle() {
    const { design } = this.props;
    const borderRadius = parseInt(design.options?.borderRadius);
    return {
      input: {
        borderRadius
      },
      image: {
        borderRadius
      }
    };
  }
  renderViewMode() {
    const { design, option, showResults, dark, t } = this.props;
    const { loading, checked } = this.state;
    const style = this.getCustomStyle();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles.option, styles.list, styles.cta, {
          [styles.with_image]: this.isImageEnabled() ? option.image?.src.url : null,
          [styles.user_choice]: this.isUserChoice(),
          [styles.dark]: dark
        }),
        style: design.option,
        onClick: this.handleVoteClick,
        onKeyPress: this.handleVoteClick,
        "aria-label": checked ? t("Poll_Viewer_Option_AriaLabel_Checked") : t("Poll_Viewer_Option_AriaLabel_Unchecked"),
        tabIndex: this.context.tabIndex,
        role: "button"
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cls(styles.overlay, {
            [styles.shown]: loading
          }),
          style: design.option
        },
        /* @__PURE__ */ React.createElement(LoaderIcon, { className: styles.spinner, width: 36, height: 36 })
      ),
      /* @__PURE__ */ React.createElement("div", { className: styles.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          dataHook: POLLS_ANSWER_TEXT_INPUT,
          maxLength: 60,
          style: style.input,
          className: cls(styles.input, {
            [styles.with_result]: showResults
          }),
          value: option.title,
          placeholder: t("Poll_Editor_Answer_Placeholder"),
          startAdornment: this.isImageEnabled() && /* @__PURE__ */ React.createElement(
            ImageUpload,
            {
              dataHook: POLLS_ANSWER_IMAGE,
              className: styles.image,
              value: option.image?.src.url,
              style: style.image,
              small: true
            }
          )
        },
        /* @__PURE__ */ React.createElement(
          "span",
          {
            className: styles.progress,
            style: {
              width: `${this.getVotePercentage()}%`
            }
          }
        ),
        showResults && /* @__PURE__ */ React.createElement("span", { className: styles.progress_value, "data-hook": POLLS_ITEM_PERCENTAGE_PREVIEW }, this.getVotePercentage(), "%")
      )),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: styles.check,
          style: {
            color: dark ? "#000" : design.poll.background
          }
        },
        /* @__PURE__ */ React.createElement(CheckIcon, { className: styles.icon })
      )
    );
  }
  renderEditMode() {
    const { design, option, removeEnabled, t, dark } = this.props;
    const style = this.getCustomStyle();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles.option, styles.list, {
          [styles.with_image]: this.isImageEnabled(),
          [styles.dark]: dark
        }),
        style: design.option
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          dataHook: POLLS_ANSWER_TEXT_INPUT,
          maxLength: 60,
          style: style.input,
          className: styles.input,
          value: option.title,
          disabled: !this.isEditAllowed(),
          placeholder: t("Poll_Editor_Answer_Placeholder"),
          onChange: this.handleTitleChange,
          endAdornment: /* @__PURE__ */ React.createElement(React.Fragment, null, !this.isEditAllowed() ? /* @__PURE__ */ React.createElement(Tooltip, { content: t("Poll_Editor_Answer_Error_NoEdit_Tooltip") }, /* @__PURE__ */ React.createElement(NonEditableIcon, { className: styles.adornment_icon })) : null, removeEnabled && /* @__PURE__ */ React.createElement(RemoveOption, { onClick: this.handleRemove })),
          startAdornment: this.isImageEnabled() && /* @__PURE__ */ React.createElement(
            ImageUpload,
            {
              dataHook: POLLS_ANSWER_IMAGE,
              disabled: !this.isEditAllowed(),
              className: styles.image,
              value: option.image?.src.url,
              onChange: this.handleImageChange,
              style: style.image,
              small: true
            }
          )
        }
      ))
    );
  }
}
PollListOption.propTypes = PollOptionBase.propTypes;
PollListOption.contextType = RicosContext;
export {
  PollListOption
};
//# sourceMappingURL=PollListOption.js.map
